export const initialState = {
  name: {
    value: "",
    isValid: true,
    errorText: ""
  },
  description: {
    value: "",
    isValid: true,
    errorText: ""
  }
};
